import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Snowball from '../game/Snowball';
import SoundAssetKeys from '../SoundAssetKeys';
import GameHud from '../ui/GameHud';
import UIAssetKeys from '../UIAssetKeys';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  init() {
    /* instructions */
    this.helperHand = null;
    this.toPickUp = null;

    /* snowballs */
    this.snowballs = null;
    this.bigBall = null;
    this.snowballContainer = null;
    this.activeDraggedSnowball = null;

    /* options */
    this.moveSnowballs = false;
    this.btnToggleMove = null;

    /* snow particles */
    this.snowBursts = null;
  }

  create() {
    this.snowballContainer = this.add.container();
    this.hud = new GameHud(this);
    this.add.existing(this.hud);

    this.snowballs = [];
    this.toPickUp = [];
    const cnt = 99;
    let snowball = null;
    let x; let y; let vx; let vy;
    for (let i = 0; i < cnt; i++) {
      this.toPickUp.push(i);// use this to pick random ones for instructions
      x = Phaser.Math.Between(100, this.scale.width - 100);
      y = Phaser.Math.Between(50,100) - 200;
      vx = Phaser.Math.Between(20,60) - 40;
      vy = Phaser.Math.Between(10,20);
      snowball = new Snowball(this, x,y,vx,vy);
      snowball.x = -111;
      snowball.y = -111;
      this.snowballContainer.add(snowball);
      this.snowballs.push(snowball);
    }

    this.bigBall = new Snowball(this, Phaser.Math.Between(100, this.scale.width - 100),-1200,0,0, true);
    this.bigBall.x = -1111;
    this.bigBall.y = -1111;
    this.snowballContainer.add(this.bigBall);
    this.snowballs.push(this.bigBall);

    this.beginInstructions();
  }

  beginInstructions () {
    this.stackSnowballs();
    Phaser.Utils.Array.Shuffle(this.toPickUp);
    const sb = this.snowballs[this.toPickUp[0]];

    this.helperHand = ABCyaPhaser.Images.addImage(sb.pos.x, sb.pos.y, UIAssetKeys._Hand_Pointer, this).setScale(1.2)
      .setAlpha(0)
      .setOrigin(0.33,0.1);
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Linear,() => this.dropFirstSnowball(sb));
  }

  stackSnowballs () {
    this.moveSnowballs = false;
    const startX = 500;
    let curX = this.scale.width - startX;
    const maxX = this.scale.width - 40;
    let curRow = 0;
    const len = this.snowballs.length;
    let sb = null;
    for (let i = 0; i < len; i++) {
      sb = this.snowballs[i];
      sb.isStacked = true;
      sb.changeVel(0,0);
      if (sb.size === 'lg') {
        sb.pos.x = 200;
        sb.pos.y = sb.bottomLimit;
      }
      else {
        sb.pos.x = curX;
        sb.pos.y = sb.bottomLimit - (sb.radius * 2 * curRow) - 8;
        curX += sb.radius * 2 - 5;
        if (curX > maxX) {
          curX = this.scale.width - startX;
          curRow++;
        }
      }
      sb.update();
    }
  }

  dropFirstSnowball (sb) {
    const x = Phaser.Math.Between(200, this.scale.width - 80);
    const y = Phaser.Math.Between(50, 300);
    ABCyaPhaser.Tweens.addTween(sb, 600, { x, y }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { x, y }, Phaser.Math.Easing.Linear, this.moveToSecondBall.bind(this));
  }

  moveToSecondBall () {
    const sb = this.snowballs[this.toPickUp[8]];
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { delay: 600, scale: 1, x: sb.pos.x, y: sb.pos.y }, Phaser.Math.Easing.Linear, () => this.dropSecondSnowball(sb));
  }

  dropSecondSnowball (sb) {
    const x = Phaser.Math.Between(200, this.scale.width - 80);
    const y = Phaser.Math.Between(50, 300);
    ABCyaPhaser.Tweens.addTween(sb, 600, { x,y }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { x, y, scale: 1 }, Phaser.Math.Easing.Linear, this.doneDroppingBalls.bind(this));
  }

  doneDroppingBalls () {
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { delay: 600, x: this.hud.btnPhysics.x + this.hud.btnPhysics.width / 2, y: this.hud.btnPhysics.y + this.hud.btnPhysics.height / 2 }, Phaser.Math.Easing.Linear, this.startInstructionFall.bind(this));
  }

  startInstructionFall () {
    this.toggleMove();
    this.hud.updateToggle(true);
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { scale: 1.2, alpha: 0 }, Phaser.Math.Easing.Linear, this.restackBalls.bind(this));
  }

  toggleMove () {
    this.moveSnowballs = !this.moveSnowballs;
    if (this.moveSnowballs) {
      this.unstackSnowballs();
    }
    return this.moveSnowballs;
  }

  unstackSnowballs () {
    const len = this.snowballs.length;
    let sb = null;
    for (let i = 0; i < len; i++) {
      sb = this.snowballs[i];
      if (sb.isStacked) {
        sb.isStacked = false;
        if (sb.size !== 'lg') sb.vel.x = Phaser.Math.Between(100,300) - 200;
      }
    }
  }

  restackBalls () {
    this.helperHand.x = this.hud.btnStack.x + this.hud.btnStack.width / 2;
    this.helperHand.y = this.hud.btnStack.y + this.hud.btnStack.height / 2;
    this.helperHand.setScale(1.2);
    this.helperHand.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.helperHand, 600, { delay: 900, scale: 1, alpha: 1 }, Phaser.Math.Easing.Linear, this.doRestack.bind(this));
  }

  doRestack () {
    this.stackSnowballs();
    const len = this.snowballs.length;
    for (let i = 0; i < len; i++) {
      const sb = this.snowballs[i];
      this.snowballs[i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.ballGrab(pointer, sb));
      this.snowballs[i].on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.ballDrag(pointer,sb));
      this.snowballs[i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => this.ballRelease(sb));
    }
    this.hud.updateToggle(this.moveSnowballs);
    this.hud.activateButtons();
    ABCyaPhaser.Tweens.addTween(this.helperHand, 400, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Linear, this.instructionHousekeeping.bind(this));
  }

  // region *** SNOWBALL INTERACTION ****
  ballGrab (pointer, snowball) {
    const sb = snowball;
    this.activeDraggedSnowball = sb;

    // these different up/out events are to catch all the different scenerios where a snowball is dragged off the game
    // this is required for desktop and dev
    this.input.once(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });

    // this is required for mobile and certain edge cases on desktop
    this.input.once(Phaser.Input.Events.POINTER_UP, () => {
      this.ballRelease(snowball);
    });

    this.snowballContainer.bringToTop(sb);
    sb.offsetX = snowball.x - pointer.x;
    if (snowball.size === 'lg' || this.game.device.os.desktop) {
      sb.offsetY = snowball.y - pointer.y;
    }
    else {
      sb.offsetY = -62;
    }
    sb.pickup(pointer.x, pointer.y);
  }

  ballDrag (pointer, snowball) {
    const sb = snowball;
    sb.drag(pointer.x, pointer.y);
  }

  ballRelease (snowball) {
    // this prevents an issue on mobile when dragging small snowballs and releasing over another snowball
    if (snowball !== this.activeDraggedSnowball) return;
    this.activeDraggedSnowball = null;

    const sb = snowball;
    this.input.off(Phaser.Input.Events.GAME_OUT);
    this.input.off(Phaser.Input.Events.POINTER_UP);
    sb.drop(!this.moveSnowballs);
  }

  // endregion *** SNOWBALL INTERACTION ***

  instructionHousekeeping () {
    this.toPickUp = null;
    this.helperHand.destroy();
    this.helperHand = null;
  }

  sideHit (snowball) {
    const speed = Math.abs(snowball.vel.x);
    let cnt = 12;
    if (speed < 6) {
      return;
    }
    else if (speed < 22) {
      cnt = 2;
    }
    else if (speed < 50) {
      cnt = 6;
    }
    if (cnt >= 6) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._sm_snow, this);
    }
  }

  update(time, delta) {
    const dt = delta / 1000;

    if (this.moveSnowballs) {
      // just do the simple move/edge check until we get the collision worked out
      let shake = false;
      let shakeAmt = false;
      const len = this.snowballs.length;
      let snowball = null;
      for (let i = 0; i < len; i++) {
        snowball = this.snowballs[i];
        if (snowball.pickedup) {
          snowball.trackMouse(dt);
        }
        else {
          snowball.move(dt);
          if (snowball.pos.y > snowball.bottomLimit) {
            snowball.pos.y = snowball.bottomLimit;
            snowball.changeVel(1,-0.3);
            shakeAmt = snowball.checkForShake();
            if (shakeAmt * -1 > 18) {
              shake = true;
              ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._lg_snow, this);
            }
          }
          else if (snowball.pos.y < snowball.topLimit) {
            snowball.pos.y = -100;
            snowball.changeVel(1,-0.1);
          }
          if (snowball.pos.x < snowball.leftLimit) {
            snowball.pos.x = snowball.leftLimit;
            snowball.changeVel(-0.1, 0.5);
            this.sideHit(snowball);
          }
          else if (snowball.pos.x > snowball.rightLimit) {
            snowball.pos.x = snowball.rightLimit;
            snowball.changeVel(-0.1, 0.5);
            this.sideHit(snowball);
          }
        }
      }

      let dist = null;
      for (let i = 0; i < len; i++) {
        snowball = this.snowballs[i];
        if (shake && snowball.pos.y === snowball.bottomLimit && snowball !== this.bigBall) {
          dist = Phaser.Math.Distance.BetweenPoints(this.bigBall.pos, snowball.pos);
          if (dist < this.bigBall.radius + snowball.radius * 2) {
            if (snowball.x < this.bigBall.x) {
              snowball.vel.x -= dist;
            }
            else {
              snowball.vel.x += dist;
            }
            snowball.vel.y -= shakeAmt * 2;
          }
        }
        snowball.tick(dt);
        snowball.update();
      }
    }
  }
}